import Navik from '@wptv/navik'

export default function ({ app }, inject) {
  Navik.setup(app, inject)
}
